import { Controller } from "@hotwired/stimulus"

// Toggles membership plan "Billing starts" between charge immediately and a
// specific first-charge date. When immediately is chosen, clears the date field
// so the form submits a blank billing_starts_on. When deferred, marks the date
// required and focuses it.
export default class extends Controller {
  static targets = ["mode", "datePanel", "dateField", "immediateHelp"]

  connect() {
    this.sync()
  }

  modeChanged() {
    this.sync({ focusDate: this.selectedMode === "date" })
  }

  sync({ focusDate = false } = {}) {
    const deferred = this.selectedMode === "date"

    if (this.hasDatePanelTarget) {
      this.datePanelTarget.classList.toggle("hidden", !deferred)
      this.datePanelTarget.setAttribute("aria-hidden", deferred ? "false" : "true")
    }
    if (this.hasImmediateHelpTarget) {
      this.immediateHelpTarget.classList.toggle("hidden", deferred)
    }
    if (this.hasDateFieldTarget) {
      this.dateFieldTarget.required = deferred
      if (!deferred) {
        this.dateFieldTarget.value = ""
      } else if (focusDate) {
        this.dateFieldTarget.focus()
      }
    }
  }

  get selectedMode() {
    const checked = this.modeTargets.find((el) => el.checked)
    return checked?.value || "immediate"
  }
}
